import { StrictMode } from 'react'
import './i18n'
import { createRoot, hydrateRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { loadBaiduStat } from './utils/loadBaiduStat'

loadBaiduStat()

const rootEl = document.getElementById('root')!
const app = (
  <StrictMode>
    <App />
  </StrictMode>
)

// 根元素带 data-geo-hydrate="client" 时，预渲染管线判定该 URL 采集失败并回退
// 到了 app-shell 静态外壳，此处必须强制走客户端渲染，不能水合外壳内容。
if (rootEl.getAttribute('data-geo-hydrate') === 'client') {
  createRoot(rootEl).render(app)
} else if (rootEl.childElementCount > 0) {
  // 容器已有真实子元素，说明加载的是预渲染产物，走水合以复用已生成的 DOM。
  hydrateRoot(rootEl, app)
} else {
  // 本地开发等场景下容器为空，走普通客户端渲染。
  createRoot(rootEl).render(app)
}
